// https://companywelfaresvil.poste.it/shopping/api/v1/orders/1204462b-fd00-48bf-aaf0-8fcbbff08583
import { refundCollection } from 'app/src/msw/refund/initialSeed/refund'
import type { refundApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const apiBaseUrl = './refund/api/v1'

export const getRefund = http.get<{ refundId: string }, object, refundApi.Refund>(
  apiBaseUrl + '/refunds/:refundId',
  async ({ params }) => {
    await new Promise((resolve) => setTimeout(resolve, 3000))

    return HttpResponse.json(refundCollection.findFirst((q) => q.where({ refundId: params.refundId }))!)
  },
)
